import type { ReactNode } from 'react'

export type NavListItem = {
  id: string
  label: ReactNode
  disabled?: boolean
}

export type NavListPreviewState =
  | 'default'
  | 'selected'
  | 'hover'
  | 'no-chevron'
  | 'no-title'
  | 'disabled-item'

export const NAV_LIST_PREVIEW_STATES: NavListPreviewState[] = [
  'default',
  'selected',
  'hover',
  'no-chevron',
  'no-title',
  'disabled-item',
]

export const NAV_LIST_PREVIEW_STATE_LABELS: Record<
  NavListPreviewState,
  string
> = {
  default: 'Default',
  selected: 'Selected',
  hover: 'Hover',
  'no-chevron': 'No chevron',
  'no-title': 'No title',
  'disabled-item': 'Disabled item',
}

export const NAV_LIST_DEMO_TITLE = 'Networks'

export const NAV_LIST_DEMO_ITEMS: NavListItem[] = [
  { id: 'ppo', label: 'DENTAL CARE PPO' },
  { id: 'premier', label: 'DENTAL CARE PREMIER' },
  { id: 'oon', label: 'OUT OF NETWORK' },
]

export type NavListProps = {
  title?: ReactNode
  items?: NavListItem[]
  /** Controlled selected item id. */
  value?: string
  /** Uncontrolled initial selection. */
  defaultValue?: string
  onChange?: (id: string) => void
  /** Trailing chevron on each row. Default `true`. */
  showChevron?: boolean
  className?: string
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: NavListPreviewState
}
